import {
  GuestWrapper,
  GuestBoxWrapper,
} from '@components/Guest/GuestBox/GuestBoxStyle';
import Guest from '@components/Guest/Guest';
import { FlightGuestBoxProps } from '@components/views/flight/types';
import ErrorMessage from '@components/Guest/GuestBox/ErrorMessage';
import { ADULT_MIN_NUMBER } from '@components/views/flight/constants';

const FlightGuestBox = ({
  numberOfAdultGuests,
  numberOfChildGuests,
  numberOfInfantGuests,
  onRemoveAdult,
  onAddAdult,
  onRemoveChild,
  onAddChild,
  onRemoveInfant,
  onAddInfant,
  errorMessages,
}: FlightGuestBoxProps) => {
  return (
    <GuestBoxWrapper>
      <GuestWrapper>
        <Guest
          key='adult'
          title='Yetişkin'
          subTitle='12+ Yaş'
          counterProps={{
            min: ADULT_MIN_NUMBER,
            disabledDecrement: numberOfAdultGuests === numberOfInfantGuests,
            count: numberOfAdultGuests,
            handleDecrement: onRemoveAdult,
            handleIncrement: onAddAdult,
          }}
        />
        <Guest
          key='child'
          title='Çocuk'
          subTitle='2-11 Yaş'
          counterProps={{
            count: numberOfChildGuests,
            handleDecrement: onRemoveChild,
            handleIncrement: onAddChild,
          }}
        />
        <Guest
          key='infant'
          title='Bebek'
          subTitle='2 Yaş altı'
          counterProps={{
            count: numberOfInfantGuests,
            handleDecrement: onRemoveInfant,
            handleIncrement: onAddInfant,
          }}
        />
      </GuestWrapper>
      <ErrorMessage errorMessages={errorMessages} />
    </GuestBoxWrapper>
  );
};

export default FlightGuestBox;
